module.exports = __webpack_public_path__ + "static/media/icon_stickers_small.396bda66.png";